module.exports = __webpack_public_path__ + "img/features_header_manajemenkontak.1ce7d17f.png";